import React, { useState, useEffect } from "react";
import {
    Button,
    InputGroup,
    Dropdown,
    DropdownButton,
    Form,
    Accordion,
    Tabs,
    Tab,
    Row,
    Col,
    Modal,
} from "react-bootstrap";
import { SETTING_FORM_URL, VIEW_SETTING_URL } from "../../../../Constant/api";
import { authService } from "../../../../Service/Axios";
import {
    nameRegex,
    alphanumericRegex,
    numericRegex,
} from "../../../../Utils/regex";
import { toast } from "react-toastify";

const VideoComp = ({
    status,
    setsettings,
    eleavailable,
    viewForm,
    setviewSetting,
    settings,
    seteleavailable,
    allElements,
    formId,
    setfirst,
    first,
    setviewForm,
    dynaDDselarr,
}) => {

    const [flagShort, setflagShort] = useState(null);

    useEffect(() => {
        if (!settings) setflagShort(null)
    }, [settings])

    const handleDelete = (ID) => {
        seteleavailable(allElements.filter((item) => item.questionId != ID));
    };

    const handleSetting = () => {
        // setopenset(k)
        viewSettingAction();
    };

    const viewSettingAction = async () => {
        const payload = {
            formId: formId,
            questionId: eleavailable[0]?.questionId,
            elementType: eleavailable[0]?.typename,
            sequenceNo: eleavailable[0]?.sequenceNo,
        };
        const response = await authService(VIEW_SETTING_URL, "POST", payload);
        if (response) {
            setviewSetting(response);
        }
        setsettings(!settings);
    };

    const handleCopy = async () => {
        const temp = Math.floor(100000 + Math.random() * 900000)
        seteleavailable([...allElements, {
            ...eleavailable[0],
            questionId: temp,
            questionName: eleavailable[0]?.questionName + '_',
            label: eleavailable[0]?.label + '_',
        }])

        const payload = {
            elementType: eleavailable[0]?.typename,
            questionId: temp,
            formId: formId,
            sectionId: eleavailable[0]?.sectionId,
            label: eleavailable[0]?.label + '_',
            sequenceNo: allElements.length,
            editfield: {
                questionName: eleavailable[0]?.questionName + '_',
                placeholderText: eleavailable[0]?.placeholderText,
                fieldDescription: eleavailable[0]?.fieldDescription,
                required: eleavailable[0]?.required,
                hidden: eleavailable[0]?.hidden,
                internal: eleavailable[0]?.internal,
                columnSpan: eleavailable[0]?.columnSpan,
                parentQuestionName: eleavailable[0]?.parentQuestionName,
                dropdownValues: eleavailable[0]?.dropdownValues,
                fileuploadtypes: eleavailable[0]?.fileuploadtypes,
                mapping: eleavailable[0]?.mapping,
                objectmap: eleavailable[0]?.objectmap,
                fieldmap: eleavailable[0]?.fieldmap,
                sectionDescription: eleavailable[0]?.sectionDescription,
                paragraph: eleavailable[0]?.paragraph,
                autoSearch: eleavailable[0]?.autoSearch,
                autoSearchEvent: eleavailable[0]?.sectionId,
                uniqueValue: eleavailable[0]?.uniqueValue,
                autoSearchKey: eleavailable[0]?.autoSearchKey,
                gridRows: eleavailable[0]?.gridRows,
                gridColumns: eleavailable[0]?.gridColumns,
            },
            validateField: {
                fieldLength: false,
                minimumLength: eleavailable[0]?.minimumLength,
                maximumLength: eleavailable[0]?.maximumLength,
                charcterType: false,
                charcterTypeValue: eleavailable[0]?.charcterTypeValue,
                patternType: false,
                patternTypeValue: "",
                numericType: false,
                numericValue: eleavailable[0]?.numericValue,
                numberRange: false,
                numberRangeValue: "",
                measurement: false,
                measurementValue: "",
                negativeNumber: eleavailable[0]?.negativeNumber,
                validation: eleavailable[0]?.validation,
            },
            globalField: eleavailable[0]?.globalField,
            addrule: eleavailable[0]?.addrule,
            show: eleavailable[0]?.show,
            mainConditions: eleavailable[0]?.mainConditions,
            calculate: eleavailable[0]?.calculate,
            calculateType: eleavailable[0]?.calculateType,
            calculateValueType: eleavailable[0]?.calculateValueType,
            calculation: eleavailable[0]?.calculation,
            calulateOthersCond: eleavailable[0]?.calulateOthersCond,
            calulateOthersMultiSelect: eleavailable[0]?.calulateOthersMultiSelect,
            calulateOthersValue: eleavailable[0]?.calulateOthersValue,
            videoURL: eleavailable[0]?.videoURL,
            imageURL: eleavailable[0]?.imageURL,
            ratingNo: eleavailable[0]?.ratingNo,
            gridOneChoiceRow: eleavailable[0]?.gridOneChoiceRow,
            gridOneChoiceColumn: eleavailable[0]?.gridOneChoiceColumn,
            gridMultiChoceRow: eleavailable[0]?.gridMultiChoceRow,
        };
        const response = await authService(SETTING_FORM_URL, "POST", payload);
        if (response) {
            toast.success("Saved Setting!");
            // setType(response.elementType);
            setsettings(false);
        }
    }

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    return (
        <Col className="mt-2 mb-2"
            xxl={
                eleavailable[0]?.columnSpan == 1
                    ? 12
                    : viewForm[0]?.columnSpan == 1 &&
                        eleavailable[0]?.columnSpan != 1 &&
                        !settings
                        ? 12
                        : viewForm[0]?.columnSpan == 1 &&
                            eleavailable[0]?.columnSpan == 1 &&
                            settings
                            ? 12
                            : 6
            }
            xl={
                eleavailable[0]?.columnSpan == 1
                    ? 12
                    : viewForm[0]?.columnSpan == 1 &&
                        eleavailable[0]?.columnSpan != 1 &&
                        !settings
                        ? 12
                        : viewForm[0]?.columnSpan == 1 &&
                            eleavailable[0]?.columnSpan == 1 &&
                            settings
                            ? 12
                            : status == "save" ? 12 : 6
            }
            lg={12}
            md={12}
            sm={12}
            xs={12}
        >

            <div
                className={`${(status == `preview` ||
                    status == `In Progress` ||
                    status == `Submitted` ||
                    status == "Published") && !viewForm[0]?.internal
                    ? `builder-row border rounded-2 bg-light preview-field`
                    : (status == `preview` ||
                        status == `In Progress` ||
                        status == `Submitted` ||
                        status == "Published") && viewForm[0]?.internal ?
                        `builder-row border rounded-2 bg-light preview-field d-none`
                        : flagShort == eleavailable[0]?.questionId ? `builder-row border rounded-2 bg-light active` : `builder-row border rounded-2 bg-light`
                    }`}
            >
                <div className="builder-row-header py-2 px-3 border-bottom d-flex">
                    <h4>
                        <span className="material-symbols-outlined align-middle me-2">
                            videocam
                        </span>{" "}
                        Video Link
                    </h4>
                    <div className="button-list ms-auto d-flex">
                        <Button variant="transparent">
                            <span
                                className="material-symbols-outlined align-middle copy-btn me-2"
                                onClick={(e) => { setflagShort(eleavailable[0]?.questionId); handleSetting(); }}
                            >
                                settings
                            </span>
                        </Button>
                        <Button variant="transparent">
                            <span className="material-symbols-outlined align-middle copy-btn me-2"
                                onClick={handleCopy}>
                                content_copy
                            </span>
                        </Button>
                        <Button variant="transparent">
                            <span
                                className="material-symbols-outlined align-middle remove-btn"
                                onClick={(e) => handleDelete(eleavailable[0]?.questionId)}
                            >
                                delete
                            </span>
                        </Button>
                    </div>
                </div>
                <div className="builder-row-body d-flex flex-wrap">
                    <div className="drag-btn d-flex justify-content-center align-items-center border-end">
                        <Button variant="transparent">
                            <span className="material-symbols-outlined">drag_indicator</span>
                        </Button>
                    </div>
                    <div className="builder-field p-3">
                        <Form.Group className="mb-3" controlId="video">
                            <Form.Label>
                                {eleavailable[0]?.label.length > 0
                                    ? eleavailable[0].label
                                    : viewForm[0]?.label.length > 0
                                        ? viewForm[0]?.label
                                        : "Add your question here"}{" "}
                                {eleavailable[0]?.required ? (
                                    <span className="text-danger"> *</span>
                                ) : viewForm[0]?.required &&
                                    !eleavailable[0]?.required &&
                                    !settings ? (
                                    <span className="text-danger"> *</span>
                                ) : viewForm[0]?.required &&
                                    eleavailable[0]?.required &&
                                    settings ? (
                                    <span className="text-danger"> *</span>
                                ) : (
                                    <span></span>
                                )}
                                <small className="d-block">
                                    {eleavailable[0]?.fieldDescription.length > 0
                                        ? eleavailable[0].fieldDescription
                                        : viewForm[0]?.fieldDescription}
                                </small>
                            </Form.Label>
                            {status == "preview" ||
                                status == "In Progress" ||
                                status == `Submitted` ||
                                status == "Published" ? (
                                <div className="rounded-3 position-relative overflow-hidden">
                                    <iframe
                                        src={
                                            (eleavailable[0]?.videoURL?.length > 0
                                                ? eleavailable[0].videoURL
                                                : viewForm[0]?.videoURL
                                            )?.replace("watch?v=", "embed/")
                                        }
                                        title="Tailwind in 100 Seconds"
                                        frameBorder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                        referrerPolicy="strict-origin-when-cross-origin"
                                        allowFullScreen
                                    ></iframe>

                                    <div className="d-flex flex-wrap align-items-center gap-2">

                                        <span className="d-inline-block px-3 py-2 border border-slate-200 bg-slate-50 text-decoration-none rounded font-medium">
                                            <label
                                                for="file"
                                                className="d-block text-center d-flex align-items-center cursor-pointer"
                                            >
                                                <i className="bx bxs-videos me-1 text-lg"></i>
                                                <span className="mb-0 text-sm text-primary">
                                                    Upload Video
                                                </span>
                                            </label>
                                            <input type="file" id="file" className="d-none" />
                                        </span>


                                        <Button onClick={handleShow} className="px-3 py-2 border border-slate-200 bg-slate-50 text-decoration-none rounded font-medium text-dark d-inline-flex align-items-center gap-1"><i className="bx bx-video text-lg"></i> Get Camera</Button>


                                    </div>

                                    <Modal show={show} onHide={handleClose} backdrop="static" centered>
                                        <Modal.Header closeButton>
                                            <Modal.Title>Record Video</Modal.Title>
                                        </Modal.Header>
                                        <Modal.Body>
                                            <span>Video content</span>
                                        </Modal.Body>
                                        <Modal.Footer>
                                            <Button variant="secondary" onClick={handleClose}>
                                                Close
                                            </Button>
                                            <Button variant="primary" onClick={handleClose}>
                                                Save Changes
                                            </Button>
                                        </Modal.Footer>
                                    </Modal>
                                </div>
                            ) : (
                                <div className="rounded-3 position-relative overflow-hidden">
                                    <iframe
                                        src={
                                            (eleavailable[0]?.videoURL?.length > 0
                                                ? eleavailable[0].videoURL
                                                : viewForm[0]?.videoURL
                                            )?.replace("watch?v=", "embed/")
                                        }
                                        title="Tailwind in 100 Seconds"
                                        frameBorder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                        referrerPolicy="strict-origin-when-cross-origin"
                                        allowFullScreen
                                    ></iframe>

                                </div>
                            )}
                        </Form.Group>
                    </div>

                </div>
            </div>
        </Col>
    );
};

export default VideoComp;
